import { useContext, useState } from "react"
import PlayerInfoContext from "../context/PlayerInfoContext"
import "../styles/Controls.css"
import { cancelGame, endGame, exitGame, startGame } from "../tools/GameTools";
import { useNavigate } from "react-router-dom";
import { pass } from "../tools/StockTools";
import { applyShareSuspend, startRound } from "../tools/RoundTools";
import { jwtDecode } from "jwt-decode";

function Controls({ size }) {
    const playerInfo = useContext(PlayerInfoContext);
    const navigate = useNavigate();
    const [startCallbackError, setStartCallbackError] = useState(null);

    if (!playerInfo) return <div></div>
    const startGameCallback = async () => {
        const result = await startGame();
        if (result.error) {
            setStartCallbackError(result.error)
            setTimeout(() => {
                setStartCallbackError(null)
            }, 5000);
        }
    }
    const copyGameURLToClipboard = async () => {
        if(navigator.share) {
            try {
                const details = jwtDecode(localStorage.getItem("token"));
                await navigator.share({
                    title: `Game #${playerInfo.gameNumber} Invitation`,
                    text: `${details.name} has invited you to join their game!`,
                    url: window.location.origin + "/join/" + playerInfo.gameId,
                })
                return;
            } catch (err) {}
        }
        navigator.clipboard.writeText(window.location.origin + "/join/" + playerInfo.gameId).then(() => {
            alert("Invite link copied, you can share it with your friends")
        }).catch(() => {
            alert("Unable to copy url")
        })
    }

    const cancelAndGoToHomepage = async () => {
        try {
            await cancelGame();
            navigate("/");
        } catch (e) { }
    }

    const startroundCallback = async () => {
        const result = await startRound();
        if (result.error) {
            setStartCallbackError(result.error)
            setTimeout(() => {
                setStartCallbackError(null)
            }, 5000);
        }
    }

    const endTheGame = async () => {
        await endGame();
    }

    const gameEndedCallback = async () => {
        await exitGame();
        navigate("/");
    }

    return (
        <div>

            {/* Admin controls and collected cards for small displays */}
            {playerInfo.isAdmin && playerInfo.waitingForGameStart && <button className="button-green" onClick={startGameCallback}>{startCallbackError || "Click here to start the game"}</button>}
            {playerInfo.isAdmin && playerInfo.waitingForGameStart && <button className="button-blue" onClick={copyGameURLToClipboard}>Click here to invite players</button>}
            {playerInfo.isAdmin && playerInfo.waitingForGameStart && <button className="button-red" onClick={cancelAndGoToHomepage}>Click here to cancel the game</button>}
            {playerInfo.isAdmin && playerInfo.waitingForNextRound && <button className="button-green" onClick={startroundCallback}>{startCallbackError || "Click here to start the round"}</button>}
            {size === "sm" && playerInfo.viewCollectedCards && <button className="button-blue" onClick={() => { window.location.href = "/collected-cards" }}>Click here to view collected cards</button>}
            {playerInfo.isAdmin && playerInfo.waitingForNextRound && <button className="button-red" onClick={endTheGame}>Click here to end the game</button>}

            {/* Current chance controls */}
            {playerInfo.chance && <button className="button-green" onClick={() => { pass() }}>{`${playerInfo.roundChanceDisplayText} : Click to skip`}</button>}

            {/* Waiting for game start controls */}
            {!playerInfo.isAdmin && playerInfo.waitingForGameStart && <button className="button-red">Waiting for admin to start the game</button>}

            {/* Waiting for next round controls */}
            {!playerInfo.isAdmin && playerInfo.waitingForNextRound && <button className="button-red">Waiting for admin to start the round</button>}


            {/* Game ended controls */}
            {playerInfo.gameEnded && <button className="button-red" onClick={gameEndedCallback}>Game Ended. Click here to enter normal world</button>}

            {/* Share Suspend Controls */}
            {playerInfo.applyShareSuspend && <button className="button-red" onClick={() => { applyShareSuspend(null) }}>{"Click to pass your share suspend"}</button>}
        
            {playerInfo.waitingForCardCollection && <button className="button-red">Cards will be collected soon</button>}
        </div>
    )
}

export default Controls